import './components/Loader.js'

export function formatValue(val, type = 'decimal') {
    const remainder = String(val).length % 4
    const decimalRestriction = (val > 999 && remainder > 0) ? 1 : 0
    const notationType = (String(val).length > 4) ? 'compact' : 'standard'

    let props = {
        style: 'decimal', 
        maximumFractionDigits: 0
    }

    if(type === 'decimal') {
        props = {
            notation: notationType,
            compactDisplay: 'short',
            maximumFractionDigits: decimalRestriction,
        }
    }
    
    if(type === 'currency') {
        props = {
            style: 'currency', 
            notation: notationType,
            compactDisplay: 'short',
            maximumFractionDigits: decimalRestriction,
            currency: 'USD'
        }

        val = Math.round(val)
    }

    if(type === 'percent') {
        props = {
            style: 'percent', 
            maximumFractionDigits: (val < 100) ? 1 : 0
        }
    }

    if(type === 'longform') {
        props = {
            maximumFractionDigits: 2,
            currency: 'USD'
        }
    }
    
    return new Intl.NumberFormat('us-EN', props).format(val)
}

export function lengthLimit(txt = '', length) {
    const arr = [...txt]
    const arrLength = arr.length

    if(arrLength > length) {
        let diff = arrLength - length

        for(let i = 0; i < diff; i++) {
            arr.pop()
        }
        
        return arr.join('') + '...'
    }

    return txt
}

export function valuePlaceholder(val) {
    if(val !== 'NaN' && val !== 'NaN%' && val !== '$NaN') return val
    return '--'
}

export function showLoader(arr, render) {
    if(arr.filter(item => item === undefined).length > 0) return `<zero-loader></zero-loader>`
    else { return render }
}